<template>
  <div class="box-foot">
    <div class="page-foot container-fluid">
      <div class="row justify-content-around">
        <a class="col-xl-1 d-none d-xl-block box-img mt-2" href="/">
          <img
            class="img1"
            src="/img/logo.png"
            width="130"
            height="60"
            alt=""
          />
          <!-- <img class="img2"  src="../style/img/picture7.png" alt="" /> -->
        </a>
        <div class="col-xl-1 col-3 ml-3 mr-3 mt-2">
          <div class="title">关于我们</div>
          <div class="mt-2">
            <a href="/AboutUs" class="title1">-公司简介</a>
          </div>

          <div class="mt-2">
            <a href="/Honor" class="title1">-荣誉资质</a>
          </div>
          <div class="mt-2">
            <a href="/WorldDuty" class="title1">-企业社会责任</a>
          </div>
          <!-- <div class="mt-2">
            <a href="/WorldDuty" class="title1">社会责任 </a>
          </div> -->
        </div>

        <div class="col-xl-1 col-3 ml-3 mr-3 mt-2">
          <div class="title">产品介绍</div>
          <div class="mt-2">
            <a href="/Arhud" class="title1">-HUD</a>
          </div>
          <!-- <div class="mt-2">
            <a href="/Whud" class="title1">W-HUD</a>
          </div> -->
          <div class="mt-2">
            <a href="/CoolingCabinet" class="title1">-车载冰箱</a>
          </div>
          <div class="mt-2">
            <a href="/peripheralProducts" class="title1">-其他智能座舱产品</a>
          </div>
        </div>
        <div class="col-xl-1 col-3 ml-3 mr-3 mt-2">
          <!-- <a class="title1" href="/News">新闻中心</a>
          <div class="mt-2">
            <a class="title1" href="/invite">招贤纳士</a>
          </div>
          <div class="mt-2"> -->
          <a class="title1" href="/cooperation">合作伙伴</a>
          <!-- </div> -->
          <div class="mt-2">
            <a class="title1" href="/News">新闻中心</a>
          </div>
          <div class="mt-2">
            <a class="title1" href="/Contact">联系我们</a>
          </div>
        </div>
        <div class="box-site col-xl-4 col-12 mt-2">
          <div class="site">
            <img src="../style/img/picture3.png" alt="" />
            <a class="ml-2"
              >上海市浦东新区新金桥路36号上海国际财富中心南塔17F</a
            >
          </div>
          <div class="mailbox mt-2">
            <img src="../style/img/picture4.png" alt="" />
            <a class="ml-2" href="#">info@pudong-inno.com</a>
          </div>
          <div class="mailbox mt-2">
            <img src="../style/img/picture5.png" alt="" />
            <a class="ml-2" href="#">021-58596661</a>
          </div>
        </div>
      </div>
      <div class="col-12 keepOnRecord">
        <div class="filing text-center" style="position: relative; z-index: 1">
          <img
            width="20"
            height="20"
            style="object-fit: contain"
            src="../style/img/beian.png"
            class="mr-1"
          />
          <!-- <a
            href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502401395"
            >沪公网安备31011502401395号</a
          >&nbsp; | &nbsp; Copyright © 浦创智能官方网站 All Rights Reserved.
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沪ICP备2024079666号-2</a
          >© 上海浦创智能科技有限公司版权所有 -->
          <a
            href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502401342"
            >沪公网安备31011502401342号</a
          >&nbsp; | &nbsp; Copyright © 浦创智能官方网站 All Rights Reserved.
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沪ICP备2024079666号-1</a
          >© 上海浦创智能科技有限公司版权所有
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XLfoot",
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .container {
    max-width: 90rem;
  }
}
@media (max-width: 1200px) {
  .box-foot {
    padding: 0 6% 0.5rem !important;
    // padding: 0 6% 3rem !important;
    // height: 30rem !important;
  }
}
.box-foot {
  // background-image: url(../style/img/picture6.png);
  background-color: rgba(45, 50, 55, 0.4);
  // background-repeat: no-repeat;
  // background-size: cover;
  padding: 5% 6% 0.5rem;
  // height: 25rem;
  // padding: 5% 6% 3rem;

  // position: relative;
  position: relative;
  z-index: 99999;
  @media (max-width: 1200px) {
    .page-foot {
      padding: 3rem 0 0;
    }
  }
  .page-foot {
    padding: 4rem 0 0;
    // position: absolute;
    // bottom: 3rem;
    // left: 12%;
    border-top: 1px solid #fff;
    .box-img {
      .img1 {
        // width: 7rem;
        // height: 3rem;
      }
      .img2 {
        margin-top: 1rem;
        width: 100%;
        // height: 6rem;
      }
    }
    .title {
      font-size: 1.2rem;
      color: #fff;
    }
    .title1 {
      white-space: nowrap;
      font-size: 1.2rem;
    }
    a {
      color: #ffffff;
      font-size: 1.1rem;
      text-decoration: none;
    }
    a:hover {
      color: #fff;
    }
    @media (max-width: 1200px) {
      .box-site {
        margin-top: 3rem !important;
      }
    }
    .site {
      color: #ffffff;
    }
    .mailbox {
      color: #ffffff;
    }
  }
  .keepOnRecord {
    color: #fff;
    margin-top: 6.5rem;
    font-size: 14px;
    padding: 0;
    .text-center {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
    a {
      font-size: 14px;
    }
  }
  @media (max-width: 1200px) {
    .keepOnRecord {
      margin-top: 2.5rem;
    }
  }
}
</style>
